import { VariationItemModel } from '@src/components/variation-picker/VariationPicker';
import { createContext, useContext } from 'react';

export type OrderInfo = {
  firstCollection?: string;
  groupId?: number;
  postcode?: string;
  productCode?: string;
  quantity: number;
  schedule?: number[];
  serviceId: number | string;
  session?: string;
  variantId?: number;
  uploadPhotos?: string[];
  description?: string;
  bidAllocationProduct?: boolean;
  selectedItem?: VariationItemModel;
  quantityRemaining?: number;
  setFirstCollection: (firstCollection?: string) => any;
  setGroupId: (groupId?: number) => any;
  setPostcode: (postcode: string) => any;
  setProductCode: (productCode?: string) => any;
  setQuantity: (quantity: number) => any;
  setSchedule: (schedule?: number[]) => any;
  setServiceId: (serviceId: number) => any;
  setSession: (session?: string) => any;
  setVariantId: (variantId?: number) => any;
  haveSuggestedItems?: boolean;
  setDescription?: (description?: string) => any;
  setHaveSuggestedItems?: (haveSuggestedItems: boolean) => any;
  setUploadPhotos?: (uploadPhotos?: string[]) => any;
  setBidAllocationProduct?: (bidAllocationProduct?: boolean) => any;
  setSelectedItem?: (quantityRemaining?: VariationItemModel) => any;
};

export const OrderInfoContext = createContext<OrderInfo>({
  quantity: -1,
  serviceId: 0,
  setFirstCollection: () => { },
  setGroupId: () => { },
  setPostcode: () => { },
  setProductCode: () => { },
  setDescription: () => { },
  setQuantity: () => { },
  setSchedule: () => { },
  setServiceId: () => { },
  setSession: () => { },
  setVariantId: () => { },
  setUploadPhotos: () => { },
});

export const useOrderInfoContext = () => useContext(OrderInfoContext);
